<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M18.1262 4.5H20.9252L14.8101 11.4892L22.0041 21H16.3712L11.9594 15.2318L6.91123 21H4.11046L10.6512 13.5242L3.75 4.5H9.52585L13.5138 9.77238L18.1262 4.5ZM17.1438 19.3246H18.6948L8.68308 6.08738H7.01869L17.1438 19.3246Z"
    fill="currentColor"
  />
</svg>
